module.exports = __webpack_public_path__ + "img/symbol_13.b12bfa3f.png";